/**
 * This const describe all type diligence.
 */
export enum DueDiligenceStatus {
    NO_CREATION = 'Sin Crear',
    CREATED = 'Creada',
    FOR_NEW_CREATION = 'Para Crear Nueva',
    APPROVED = 'Aprobada',
    REJECTED = 'Rechazada',
    NOTIFIED = 'Notificada',
    ERROR = 'Error',
}

export type TDueDiligenceModalType = 'ERROR' | 'REDIRECT' | 'UPDATE' | null;

export const DUE_DILIGENCE_FORM_REQUIREMENT =
    'Serás redirigido para que completes el formulario de Debida Diligencia. Una vez aprobado, podrás continuar usando la plataforma.';
export const DUE_DILIGENCE_REDIRECTION_TEXT =
    'Dirígete a la pestaña que se acaba de abrir, diligencia el formulario y regresa a terminar el proceso de compra.';
export const DUE_DILIGENCE_VALIDATION_TEXT =
    'Estamos procesando la validación de la información registrada en tu formulario de debida diligencia.';
export const DUE_DILIGENCE_REJECTED_TEXT =
    'No podemos continuar el proceso de registro; por favor, contáctanos para obtener detalles del proceso.';
export const DUE_DILIGENCE_ERROR = 'En este momento no podemos validar tu estado de debida diligencia. Intentalo nuevamente.';
